import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StudentResponseModel } from 'data/student/student.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: StudentResponseModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<StudentResponseModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const studentSlice = createSlice({
  name: 'system',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default studentSlice;
